import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Row, Col, Button, Card } from "react-bootstrap";
import Layout from "../../layout/Layout";
import Fancybox from "../../Component/FancyBox";
import { API } from "../../App";
import Cookies from "js-cookie";

const WallpaperView = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({
    sort_order: "",
    theme_id: "",
    wallpaper_name: "",
    resolution: "",
    resolution_ipad: "",
    category: "",
    tags: [],
    thumbnail_url: "",
    wallpaper_url: "",
    wallpaper_url_ipad: "",
    full_image: "",
    full_image_ipad: "",
    premium: "",
    status: "",
    created_at: "",
    updated_at: "",
  });

  const loadData = async (_id) => {
    setLoading(true);
    const token = Cookies.get("jwt");
    const res = await API.post(
      `/wallpapers/${_id}`,
      {},
      { headers: { authorization: `Bearer ${token}` } },
    );
    const data = res.data.data;
    setUser({
      sort_order: data.sort_order,
      theme_id: data.theme_id,
      wallpaper_name: data.wallpaper_name,
      resolution: data.resolution,
      resolution_ipad: data.resolution_ipad,
      category: data.category?.name || "",
      tags: data.tags || [],
      thumbnail_url: data.thumbnail_url,
      wallpaper_url: data.wallpaper_url,
      wallpaper_url_ipad: data.wallpaper_url_ipad,
      full_image: data.full_image,
      full_image_ipad: data.full_image_ipad,
      premium: data.premium,
      status: data.status,
      created_at: data.created_at,
      updated_at: data.updated_at,
    });
    setLoading(false);
  };

  useEffect(() => {
    loadData(id);
  }, [id]);

  return (
    <Layout sidebar={true}>
      <div className="page-heading">
        <h3>
          <Link to="/wallpaper" className="btn btn-primary btn-icon me-3">
            <i className="bx bxs-left-arrow-alt"></i>
          </Link>
          View Wallpaper - <span>{user.wallpaper_name}</span>
        </h3>
        <Row className="align-items-center">
          <Col md="auto" xs={6}>
            <Link to={`/wallpaper/edit/${id}`}>
              <Button variant="primary" value="edit">
                Edit
              </Button>
            </Link>
          </Col>
        </Row>
      </div>
      <div className="page-content">
        <Card>
          <Card.Body>
            {loading ? <div className="loader table-loader"></div> : <></>}
            <Fancybox>
              <Row>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">New Index</p>
                    <span>{user.sort_order}</span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Theme</p>
                    <span>{user.theme_id?.name || "Global"}</span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Name</p>
                    <span>{user.wallpaper_name}</span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Category</p>
                    <span>{user.category || "-"}</span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Thumbnail</p>
                    <span>
                      {user.thumbnail_url ? (
                        <a data-fancybox="gallery" href={user.thumbnail_url}>
                          <img
                            src={user.thumbnail_url}
                            className="hv-30 rounded-3"
                            alt="Thumbnail"
                          />
                        </a>
                      ) : (
                        "-"
                      )}
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Wallpaper</p>
                    {user.wallpaper_url ? (
                      <a data-fancybox="gallery" href={user.wallpaper_url}>
                        <img
                          src={user.wallpaper_url}
                          className="hv-30 rounded-3 w-100"
                          alt="Wallpaper"
                        />
                      </a>
                    ) : (
                      "-"
                    )}
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Wallpaper (iPad)</p>
                    <span>
                      {user.wallpaper_url_ipad ? (
                        <a
                          data-fancybox="gallery"
                          href={user.wallpaper_url_ipad}
                        >
                          <img
                            src={user.wallpaper_url_ipad}
                            className="hv-30 rounded-3"
                            alt="Wallpaper iPad"
                          />
                        </a>
                      ) : (
                        "-"
                      )}
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Full Image (iPhone)</p>
                    <span>
                      {user.full_image ? (
                        <a data-fancybox="gallery" href={user.full_image}>
                          <img
                            src={user.full_image}
                            className="hv-30 rounded-3"
                            alt="Full iPhone"
                          />
                        </a>
                      ) : (
                        "-"
                      )}
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Full Image (iPad)</p>
                    <span>
                      {user.full_image_ipad ? (
                        <a data-fancybox="gallery" href={user.full_image_ipad}>
                          <img
                            src={user.full_image_ipad}
                            className="hv-30 rounded-3"
                            alt="Full iPad"
                          />
                        </a>
                      ) : (
                        "-"
                      )}
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Resolution</p>
                    <span>{user.resolution || "-"}</span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Resolution (iPad)</p>
                    <span>{user.resolution_ipad || "-"}</span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Tags</p>
                    <span className="d-flex flex-wrap gap-1">
                      {Array.isArray(user.tags) && user.tags.length
                        ? user.tags.map((tag, i) => (
                            <span
                              key={`${tag}-${i}`}
                              className="badge bg-primary"
                            >
                              {tag}
                            </span>
                          ))
                        : "-"}
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Premium</p>
                    <span>{user.premium ? "True" : "False"}</span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Status</p>
                    <span>{user.status ? "True" : "False"}</span>
                  </div>
                </Col>
              </Row>
            </Fancybox>
          </Card.Body>
        </Card>
      </div>
    </Layout>
  );
};

export default WallpaperView;
